import React from "react";
import DefaultTab from "./defaultTab";

const ClassicTab = props => {
  return (
    <DefaultTab
      {...props}
      noBorderBottomTab
      navLinkClass="oui-nav-link-classic"
      navItemClass="oui-nav-item-classic"
      bodyClass="oui-tab-body-classic"
    />
  );
};

export default ClassicTab;
